import Vue from 'vue'
import { store } from './store'
import VueCookies from 'vue-cookies'
import { BootstrapVue, BootstrapVueIcons, IconsPlugin } from 'bootstrap-vue'

import Config from '@/config/vueconfig.js'
import Directive from '@/helper/Directive.js'
import _ from 'lodash'

import Antd from 'ant-design-vue/lib'
import VueMeta from 'vue-meta'
import 'bootstrap/dist/css/bootstrap.css'
import 'ant-design-vue/dist/antd.min.css'
import Cache from '@/helper/Cache.js'
import Locale from '@/helper/Locale.js'

import App from './App.vue'
import router from './router'
import Loading from '@/components/Loading/Loading'
import FooterMenu from '@/components/Layout/FooterMenu'
import Language from '@/components/Layout/changeLanguage'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import AccountHelper from './helper/AccountHelper'
import OtpInput from '@bachdgvn/vue-otp-input'
import LoadMore from 'vue-scroll-loadmore'
import BzbsApi from '@/core/Http/BzbsApi.js'
import GifPlayer from 'vue-gifplayer/src/component'

import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css'
import 'vue-gifplayer/src/gif.css'
import Mixin from '@/mixin/CommonMixin'

Vue.component('Loading', Loading)
Vue.component('FooterMenu', FooterMenu)
Vue.component('Language', Language)
Vue.component('v-otp-input', OtpInput)
Vue.component('vue-cookie-accept-decline', VueCookieAcceptDecline)
Vue.component('gif-player', GifPlayer)

Vue.config.productionTip = false
Vue.config.devtools = true
Vue.use(VueCookies)
Vue.use(Config)
Vue.use(Antd)
Vue.use(Directive)
Vue.use(LoadMore)
Vue.use(VueMeta)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueMoment, moment)
Vue.use(IconsPlugin)
router.beforeEach((to, from, next) => {
  next()
})
router.afterEach(() => {})

new Vue({
  mixins: [Mixin],
  router,
  store,
  watch: {
    $route(to, from) {
      if (!to.hash && to.name !== from.name) {
        this.$store.commit('Loading', true)
        this.$store.commit('FooterMenu', true)
      }
    },
  },
  beforeCreate() {
    //Check url line liff
    console.log('Check url line liff')
    if (Vue.bzbsConfig.debug) {
      if (!_.isEmpty(this.$route.fullPath)) {
        let decodeURI = decodeURIComponent(this.$route.fullPath)
        if (decodeURI.includes('#')) {
          var full_path1 = decodeURI.split('#', 1)
          if (full_path1) {
            var origin1 = window.location.origin
            if (
              !origin1.includes('liff.line.me') &&
              !origin1.includes('line://app')
            ) {
              window.location = window.location.origin + full_path1
            } else {
              window.location = window.location.origin
            }
          }
        } else if (decodeURI.includes('?state=')) {
          var full_path2 = decodeURI.split('?state=')[0]
          if (full_path2) {
            var origin2 = window.location.origin
            if (
              !origin2.includes('liff.line.me') &&
              !origin2.includes('line://app')
            ) {
              window.location = window.location.origin + full_path2
            } else {
              window.location = window.location.origin
            }
          }
        } else if (decodeURI.includes('&state=')) {
          var full_path3 = decodeURI.split('&state=')[0]
          if (full_path3) {
            var origin3 = window.location.origin
            if (
              !origin3.includes('liff.line.me') &&
              !origin3.includes('line://app')
            ) {
              window.location = window.location.origin + full_path3
            } else {
              window.location = window.location.origin
            }
          }
        }
      }
    }
  },
  created() {
    Vue.initFinished = false
    console.log('main route : ', this.$route)
    if (!_.isEmpty(this.$route.query.debug)) {
      if (this.$route.query.debug) {
        alert('Main route FullPath => ' + this.$route.fullPath)
      }
    }
    Locale.setLocale(this.$route, window.location).then(() => {
      Locale.getLocale()
      if (Cache.get('BzbsLocale')) {
        Locale.getLbl()
        AccountHelper.initial()
      }
      if (Vue.bzbsConfig.businessRule.config.Azure) {
        var url
        if (window.location.hostname == 'localhost') {
          url =
            'https://dev-web-crm-plus-consumer.azurewebsites.net/api/version'
        } else {
          url = window.location.origin + '/api/version'
        }
        BzbsApi.connectBzbsGetBlob(url).then(res => {
          var response = { ...res.data.api_setting }
          var feature = { ...res.data.config_setting }
          let errorArray = {}
          let catchConfig = {}
          let catchFeature = {}
          Object.keys(response).forEach(i => {
            if (response[i]) {
              catchConfig[i] = response[i]
            } else {
              errorArray[i] = i
            }
          })
          Object.keys(feature).forEach(i => {
            catchFeature[i] = feature[i]
          })
          if (
            Object.keys(errorArray).length > 0 &&
            window.location.pathname !== '/PageNotFindConfig'
          ) {
            this.$router.push({
              name: 'PageNotFindConfig',
              query: errorArray,
            })
          } else {
            if (response) {
              Vue.bzbsConfig.bzbUrlService = response.bzbUrlService
              Vue.bzbsConfig.bzbModuleUrl = response.bzbModuleUrl
              Vue.bzbsConfig.bzbBlobUrl = response.bzbBlobUrl
              Vue.bzbsConfig.bzbEwalletUrl = response.bzbEwalletUrl
              Vue.bzbsConfig.bzbsAnalyticUrl = response.bzbsAnalyticUrl
              Vue.bzbsConfig.bzbsGiftCardWalletUrl =
                response.bzbsGiftCardWalletUrl
              Vue.bzbsConfig.bzbsBeeRewardUrl = response.bzbsBeeRewardUrl
              Vue.bzbsConfig.bzbsBpsPosUrl = response.bzbsBpsPosUrl
              Vue.bzbsConfig.bzbsCashcardUrl = response.bzbsCashcardUrl
            }
            if (feature) {
              Vue.bzbsConfig.businessRule.config.Facebook =
                feature.FeatureFacebook
            }
          }
        })
      }
    })
  },
  mounted() {},
  render: h => h(App),
}).$mount('#app')
